import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";


const GlobalSidebarMenu = ({sidebarTitle}) => {
    const location = useLocation();

    const { user } = useSelector((store) => store.auth);
    const {summery} = user

    const isActive = (path) => {
        return location.pathname === path || (location.pathname.startsWith(path) && path !== '/') ? 'active-menu' : '';
      };
    return (
        <div className="card-menu-wrapper">
            <div className="sticky-area">
                <ul>
                    <li>
                        <Link className={isActive('/')} to="/"><i className="ri-home-4-line"></i> <span>Home</span></Link>
                    </li>
                    <li>
                        <Link className={isActive('/card')} to="/card"><i className="ri-id-card-line"></i> <span>Card</span> <span className="sts-count">{summery?.createdCard}</span></Link>
                    </li>
                    <li>
                        <Link className={isActive('/connection')} to="/connection"><i className="ri-group-line"></i> <span>Connection</span> <span className="sts-count">{summery?.connectionCount}</span></Link>
                    </li>
                    <li>
                        <Link className={isActive('/lead')} to="/lead"><i className="ri-user-line"></i> <span>Lead</span> <span className="sts-count">{summery?.prospectCount}</span></Link>
                    </li>
                    <li>
                        <Link className={isActive('/business')} to="/business"><i className="ri-building-line"></i> <span>Business</span></Link>
                    </li>
                    <li>
                        {/* <Link className={isActive('/subscription')} to="/subscription"><i className="ri-bank-card-2-line"></i> <span>Subscription</span></Link> */}
                    </li>
                    <li>
                        <Link className={isActive('/notification')} to="/notification"><i className="ri-notification-2-line"></i> <span>Notification</span> <span className="sts-count">{summery?.notificationUnread}</span></Link>
                    </li>
                    <li>
                        <Link className={isActive('/gallery')} to="/gallery"><i className="ri-gallery-line"></i> <span>Gallery</span></Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default GlobalSidebarMenu;
